import Logger from '@KrashidBuilt/common/utils/logger';

import { get } from './api';
import { SPEEDLABEL_WEB_API_BASE } from '../constants';

const logger = new Logger(__filename);

export const getOne = async ({ jobId }) => {
    logger.extra({ jobId });
    return await get(`${SPEEDLABEL_WEB_API_BASE}/api/private/jobs/${jobId}`);
};

export const refreshCacheAndGet = async ({ jobId }) => {
    logger.extra({ jobId });
    return await get(`${SPEEDLABEL_WEB_API_BASE}/api/private/jobs/${jobId}/refresh`);
};

export const getSheet = async ({ jobId }) => await get(`${SPEEDLABEL_WEB_API_BASE}/api/private/jobs/${jobId}/sheet`);